import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import {Link} from 'react-router-dom'
import NavAusbildungsnachweise from '#components/svg/icons/NavAusbildungsnachweise'
import NavAusbildungsplan from '#components/svg/icons/NavAusbildungsplan'
import NavMeineAzubis from '#components/svg/icons/NavMeineAzubis'
import NavMeineAusbildung from '#components/svg/icons/NavMeineAusbildung'
import NavStatusUebersicht from '#components/svg/icons/NavStatusUebersicht'
import NavVersetzungsplan from '#components/svg/icons/NavVersetzungsplan'
import NavWissensPortal from '#components/svg/icons/NavWissensPortal'
import ArrowLeft from '#components/svg/icons/ArrowLeft'

export default function HeaderLink(props) {
  const {titleKey, url} = props
  return (
    <Link className="header-link" to={url}>
      {renderIcon(titleKey)}
      <span className="text">{i18n.t(titleKey)}</span>
      <ArrowLeft />
    </Link>
  )
}

function renderIcon(titleKey) {
  switch (titleKey) {
    case 'menu_item_meineausbildung':
      return <NavMeineAusbildung />
    case 'menu_item_meineazubis':
      return <NavMeineAzubis />
    case 'menu_item_ausbildungsnachweise':
      return <NavAusbildungsnachweise />
    case 'menu_item_ausbildungsplan':
      return <NavAusbildungsplan />
    case 'menu_item_versetzungsplan':
      return <NavVersetzungsplan />
    case 'menu_item_praxisaufgabenOverview':
      return <NavStatusUebersicht />
    case 'menu_item_wissensportal':
      return <NavWissensPortal />
    default:
      return null
  }
}

HeaderLink.propTypes = {
  titleKey: PropTypes.string,
  url: PropTypes.node,
}
